import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  TextField,
  FormControl,
  InputLabel,
  Tooltip,
  InputAdornment,
  Select,
  MenuItem,
  DialogActions,
} from "@material-ui/core";

import { MuiThemeProvider } from "@material-ui/core/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Toolbar, AppBar } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import Cookies from "js-cookie";

import axios from "axios";
import useStyles from "../themes/style";
import { useHistory, useLocation, useParams } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import "react-toastify/dist/ReactToastify.css";

import "../css/agreement-resume.css";
import "../css/candidate_offer_page.css";
import { getMuiTheme } from "./style";
import { MdMessage } from "react-icons/md";
import { useNotification } from "../hooks/useNotification";
import { IoAdd, IoRemove } from "react-icons/io5";
import moment from "moment";

const bloodGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];

const maritalStatusList = [
  "Single",
  "Married",
  "Divorced",
  "Widowed",
  "Separated",
  "Prefer not to say",
];

function CandidateSelfProfileAdd() {
  const token = localStorage.getItem("token");
  //   const decode = jwtDecode(token);
  const history = useHistory();
  const handleNotificationCall = useNotification();
  const { candidateId, userId } = useParams();
  const location = useLocation();
  const [modalOpen, setModalOpen] = useState(false);
  const [candAlreadyAdded, setCandAlreadyAdded] = useState(false);
  // const [contractPeriod, setContractPeriod] = useState([]);

  const handleModalClose = () => {
    setModalOpen(false);
  };
  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const theme = useTheme();
  const classes = useStyles();
  const isMatch = useMediaQuery(theme.breakpoints.down("sm"));

  const [loader, setLoader] = useState(false);
  const [candidateData, setCandidateData] = useState({});

  const validationSchema = Yup.object().shape({
    dataId: Yup.string(),
    firstName: Yup.string()
      .max(255)
      .required("First Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "First Name be Alphanumeric",
      }),
    lastName: Yup.string()
      .max(255)
      .required("Last Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Last Name be Alphanumeric",
      }),
    mobile: Yup.string()
      .required("Mobile is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),

    //employee schema
    dob: Yup.date()
      .typeError("Invalid Date of Birth")
      .nullable()
      .required("Date of Birth field is required"),
    gender: Yup.string().nullable().required("Gender is required"),
    bloodGroup: Yup.string()
      .nullable()
      .required("Select Blood Group is required"),
    maritalStatus: Yup.string()
      .nullable()
      .required("Marital Status is required"),
    spouseName: Yup.string().required("Spouce Name is required"),

    personalEmail: Yup.string()
      .required("Personal Email is required")
      .email("Email must be a Valid Email Address"),

    fatherName: Yup.string().required("Father Name is required"),
    motherName: Yup.string().required("Mother Name is required"),
    emergencyMobile: Yup.string()
      .required("Emergency Contact Number is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    emergencyContactRelation: Yup.string().required(
      "Mention Relationship is required",
    ),
    currentAddress: Yup.string().required("Current Address is required"),
    permanentAddress: Yup.string().required("Permanent Address is required"),
    totalExperience: Yup.string().required(
      "Total Experience field is required",
    ),

    aadhaarNumber: Yup.string().required("Aadhar Number is required"),
    panNumber: Yup.string().required("PAN Number is required"),
    pfNumber: Yup.string().nullable().notRequired(),
    uanNumber: Yup.string().nullable().notRequired(),
    esiNumber: Yup.string().nullable().notRequired(),
  });

  const {
    register,
    control,
    setValue,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {},
  });

  const handleEmployeeDataSubmit = async (values) => {
    try {
      if (values.dataId) {
        handleEditEmployee(values);
      } else {
        const { dataId, ...empData } = values;

        handleAddEmployee(empData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddEmployee = async (values) => {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}employee/addEmployeeCandidate`,
        { ...values, candidateId: candidateId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        Cookies.set(`cand_form_filled${candidateId}`, "true", {
          expires: 20,
          path: `/`,
        });
        fetchCandidateDetails();
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleEditEmployee = async (values) => {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}employee/editEmployeeCandidate`,
        { ...values, candidateId: candidateId, id: values.dataId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        Cookies.set(`cand_form_filled${candidateId}`, "true", {
          expires: 20,
          path: `/`,
        });
        fetchCandidateDetails();
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  useEffect(() => {
    const candidateCookie = Cookies.get(`cand_form_filled${candidateId}`);
    if (candidateCookie) {
      fetchCandidateDetails();
      // history.push(`/candidate-self-profile/${candidateId}/${userId}`);
    } else {
      handleModalOpen();
    }

    // setModalOpen(true);
    // fetchCandidateDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCandidateDetails = async (values) => {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}employee/viewOpenEmployeeCandidate`,
        {
          candidateId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        const candiData = response.data.data;
        console.log(candiData);
        if (candiData) {
          setCandidateData(candiData);
          setValue("dataId", candiData.id);
          setValue("firstName", candiData.firstName);
          setValue("lastName", candiData.lastName);
          setValue("mobile", candiData.mobile);
          setValue("personalEmail", candiData.personalEmail);
          setValue("maritalStatus", candiData.maritalStatus);
          setValue("currentAddress", candiData.currentAddress);
          setValue("permanentAddress", candiData.permanentAddress);
          setValue("emergencyMobile", candiData.emergencyMobile);

          setValue("fatherName", candiData.fatherName);
          setValue("motherName", candiData.motherName);
          setValue("spouseName", candiData.spouseName);
          setValue("permanentAddress", candiData.permanentAddress);
          setValue("dob", moment(candiData.dob).format("YYYY-MM-DD"));
          setValue("gender", candiData.gender);
          setValue(
            "emergencyContactRelation",
            candiData.emergencyContactRelation,
          );
          setValue("bloodGroup", candiData.bloodGroup);
          setValue("totalExperience", candiData.totalExperience);
          setValue("uanNumber", candiData.uanNumber);
          setValue("pfNumber", candiData.pfNumber);
          setValue("esiNumber", candiData.esiNumber);
          setValue("aadhaarNumber", candiData.aadhaarNumber);
          setValue("panNumber", candiData.panNumber);
        } else {
          setCandAlreadyAdded(true);
        }
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  return (
    <div className={classes.backgroundColor}>
      <MuiThemeProvider theme={getMuiTheme()}>
        <>
          <AppBar className={classes.appBarBg}>
            <Toolbar className={classes.toolbarLP}>
              {isMatch ? (
                <>
                  <div className={classes.refoTitleMobile}>
                    <p className="refo-name">refo</p>
                  </div>
                  <div className={classes.flexCenter} style={{ width: "100%" }}>
                    <div className="refo-full-name">
                      <h1>
                        refo<span>recruiter essentials & faster outcomes</span>
                      </h1>
                    </div>
                  </div>
                  {/* <DrawerComp /> */}
                </>
              ) : (
                <Grid className={classes.gridCenter} container spacing={2}>
                  <Grid item xs={1} md={1} className={classes.refoTitle}>
                    <p className="refo-name">refo</p>
                  </Grid>
                  <Grid item xs={11} md={11} className={classes.flexCenter}>
                    <div className="refo-full-name">
                      <h1>
                        refo<span>recruiter essentials & faster outcomes</span>
                      </h1>
                    </div>
                  </Grid>
                </Grid>
              )}
            </Toolbar>
          </AppBar>

          <div style={{ marginTop: "5rem", overflow: "auto", height: "90vh" }}>
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                paddingBlock: "3rem",
              }}
            >
              <div
                className="details-form-card"
              >
                <div className="details-form-header">
                  <span className="icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M12 1C8.96243 1 6.5 3.46243 6.5 6.5C6.5 9.53757 8.96243 12 12 12C15.0376 12 17.5 9.53757 17.5 6.5C17.5 3.46243 15.0376 1 12 1Z"
                          fill="#ffffff"
                        ></path>
                        <path
                          d="M7 14C4.23858 14 2 16.2386 2 19V22C2 22.5523 2.44772 23 3 23H21C21.5523 23 22 22.5523 22 22V19C22 16.2386 19.7614 14 17 14H7Z"
                          fill="#ffffff"
                        ></path>
                      </g>
                    </svg>
                  </span>
                  <p className="alert">Employee Form</p>
                </div>
                <div>
                  {candidateData ? (
                    <form
                      onSubmit={handleSubmit(handleEmployeeDataSubmit)}
                      autoComplete="off"
                      noValidate
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          style={{ fontsize: "16px" }}
                          color="#818080"
                        >
                          Personal Details
                        </Typography>
                        <Grid container direction="row" spacing={3}>
                          <TextField
                            size="small"
                            classes={{ root: classes.customTextField }}
                            InputProps={{ disableUnderline: true }}
                            placeholder="Enter First Name"
                            name="dataId"
                            {...register("dataId")}
                            style={{ display: "none" }}
                            defaultValue={candidateData?.dataId}
                          />
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="firstName">
                              First Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter First Name"
                                id="firstName"
                                name="firstName"
                                {...register("firstName")}
                                defaultValue={candidateData?.firstName}
                                error={errors.firstName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.firstName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="lastName">
                              Last Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Enter Last Name"
                                id="lastName"
                                name="lastName"
                                {...register("lastName")}
                                defaultValue={candidateData?.lastName}
                                error={errors.lastName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.lastName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="dob">
                              Date of Birth
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                InputProps={{ disableUnderline: true }}
                                classes={{ root: classes.customTextField }}
                                size="small"
                                type="date"
                                placeholder="Select employee date of birth"
                                id="dob"
                                {...register("dob")}
                                defaultValue={candidateData?.dob}
                                error={errors.dob ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.dob?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="gender">
                              Gender
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <Controller
                                name="gender"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    value={value}
                                    onChange={(e) => onChange(e.target.value)}
                                    error={errors.gender ? true : false}
                                    classes={{
                                      root: classes.customSelectField,
                                      icon: classes.customSelectIcon,
                                    }}
                                    disableUnderline
                                  >
                                    <MenuItem value="">Select option</MenuItem>
                                    <MenuItem value="Male">Male</MenuItem>
                                    <MenuItem value="Female">Female</MenuItem>
                                    <MenuItem value="Transgender">
                                      Transgender
                                    </MenuItem>
                                    <MenuItem value="Prefer not to say">
                                      Prefer not to say
                                    </MenuItem>
                                  </Select>
                                )}
                              />
                              <Typography variant="inherit" color="error">
                                {errors.gender?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="bloodGroup">
                              Blood Group
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <Controller
                                name="bloodGroup"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    value={value}
                                    onChange={(e) => onChange(e.target.value)}
                                    error={errors.bloodGroup ? true : false}
                                    classes={{
                                      root: classes.customSelectField,
                                      icon: classes.customSelectIcon,
                                    }}
                                    disableUnderline
                                  >
                                    <MenuItem value="">Select option</MenuItem>
                                    {bloodGroups.map((group) => (
                                      <MenuItem key={group} value={group}>
                                        {group}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                )}
                              />
                              <Typography variant="inherit" color="error">
                                {errors.bloodGroup?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="maritalStatus">
                              Marital Status
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <Controller
                                name="maritalStatus"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    value={value}
                                    onChange={(e) => onChange(e.target.value)}
                                    error={errors.maritalStatus ? true : false}
                                    classes={{
                                      root: classes.customSelectField,
                                      icon: classes.customSelectIcon,
                                    }}
                                    disableUnderline
                                  >
                                    <MenuItem value="">Select option</MenuItem>
                                    {maritalStatusList.map((group) => (
                                      <MenuItem key={group} value={group}>
                                        {group}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                )}
                              />
                              <Typography variant="inherit" color="error">
                                {errors.maritalStatus?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="spouseName">
                              Spouse Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Spouse Name"
                                name="spouseName"
                                {...register("spouseName")}
                                defaultValue={candidateData?.spouseName}
                                error={errors.spouseName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.spouseName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="mobile">
                              Contact Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                type="number"
                                placeholder="Enter Mobile Number"
                                id="mobile"
                                name="mobile"
                                {...register("mobile")}
                                defaultValue={candidateData?.mobile}
                                error={errors.mobile ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.mobile?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="personalEmail">
                              Personal Email
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Enter Persaonal Email"
                                name="personalEmail"
                                {...register("personalEmail")}
                                defaultValue={candidateData?.personalEmail}
                                error={errors.personalEmail ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.personalEmail?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="fatherName">
                              Father Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Father Name"
                                name="fatherName"
                                {...register("fatherName")}
                                defaultValue={candidateData?.fatherName}
                                error={errors.fatherName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.fatherName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="motherName">
                              Mother Name
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Enter Mother Name"
                                name="motherName"
                                {...register("motherName")}
                                defaultValue={candidateData?.motherName}
                                error={errors.motherName ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.motherName?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="emergencyMobile">
                              Emergency Contact Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                type="number"
                                placeholder="Enter Emergency Mobile Number"
                                id="emergencyMobile"
                                name="emergencyMobile"
                                {...register("emergencyMobile")}
                                defaultValue={candidateData?.emergencyMobile}
                                error={errors.emergencyMobile ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.emergencyMobile?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel
                              shrink
                              htmlFor="emergencyContactRelation"
                            >
                              Emergency Contact Name & Relationship
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Enter Emergency Contact Name & Relationship"
                                name="emergencyContactRelation"
                                {...register("emergencyContactRelation")}
                                error={
                                  errors.emergencyContactRelation ? true : false
                                }
                                defaultValue={
                                  candidateData?.emergencyContactRelation
                                }
                              />

                              <Typography variant="inherit" color="error">
                                {errors.emergencyContactRelation?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="currentAddress">
                              Current Address
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Current Address"
                                name="currentAddress"
                                {...register("currentAddress")}
                                defaultValue={candidateData?.currentAddress}
                                error={errors.currentAddress ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.currentAddress?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="permanentAddress">
                              Permanent Address
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Enter Permanent Address"
                                name="permanentAddress"
                                {...register("permanentAddress")}
                                defaultValue={candidateData?.permanentAddress}
                                error={errors.permanentAddress ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.permanentAddress?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="totalExperience">
                              Total Experience (in Years)
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter Employee Total Experience"
                                name="totalExperience"
                                {...register("totalExperience")}
                                defaultValue={candidateData?.totalExperience}
                                error={errors.totalExperience ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.totalExperience?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="aadhaarNumber">
                              Aadhaar Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Enter Aadhaar Number"
                                name="aadhaarNumber"
                                {...register("aadhaarNumber")}
                                defaultValue={candidateData?.aadhaarNumber}
                                error={errors.aadhaarNumber ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.aadhaarNumber?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="panNumber">
                              PAN Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter PAN Number"
                                name="panNumber"
                                {...register("panNumber")}
                                error={errors.panNumber ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.panNumber?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="pfNumber">
                              PF Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter PF Account Number"
                                name="pfNumber"
                                {...register("pfNumber")}
                                defaultValue={candidateData?.pfNumber}
                                error={errors.pfNumber ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.pfNumber?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="uanNumber">
                              UAN Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter PAN Number"
                                name="uanNumber"
                                {...register("uanNumber")}
                                defaultValue={candidateData?.uanNumber}
                                error={errors.uanNumber ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.uanNumber?.message}
                              </Typography>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} lg={6}>
                            <InputLabel shrink htmlFor="esiNumber">
                              ESI Number
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                size="small"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                placeholder="Enter ESI Number"
                                name="esiNumber"
                                {...register("esiNumber")}
                                defaultValue={candidateData?.esiNumber}
                                error={errors.esiNumber ? true : false}
                              />

                              <Typography variant="inherit" color="error">
                                {errors.esiNumber?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </div>
                      <Grid
                        container
                        direction="row"
                        spacing={3}
                        style={{
                          padding: "30px 10px 20px",
                          display: "flex",
                          justifyContent: "end",
                          gap: "20px",
                        }}
                      >
                        <div style={{ flex: 1 }}></div>
                        <div style={{ flex: 1 }}></div>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          disabled={isSubmitting}
                          style={{ flex: 1 }}
                          type="submit"
                        >
                          Save
                        </Button>
                      </Grid>
                    </form>
                  ) : (
                    <p
                      style={{ fontSize: "1.35rem", color: "green" }}
                    >
                      Congrats! You are now an employee.Kindly contact HR/admin
                      for any queries.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <Dialog maxWidth="xs" open={modalOpen} onClose={handleModalClose}>
            <DialogContent>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      alignItems: "center",
                    }}
                  >
                    <span
                      className="icon"
                      style={{
                        width: "1.3rem",
                        height: "1.3rem",
                        padding: "12px",
                        background: "#d07126",
                      }}
                    >
                      !
                    </span>
                    <p style={{ fontSize: "18px", fontWeight: 600, margin: 0 }}>
                      Message
                    </p>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2">
                    Thank you for accepting Offer!
                    <br />
                    Fill Employee form now or later by clicking the same mail
                    link.
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions></DialogActions>
          </Dialog>

          <ToastContainer
            closeButton={
              <CloseButton className={classes.notificationCloseButton} />
            }
            closeOnClick={false}
            hideProgressBar={true}
          />
          <Backdrop className={classes.backdrop} open={loader}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      </MuiThemeProvider>
    </div>
  );
}

export default CandidateSelfProfileAdd;
function CloseButton({ closeToast, className }) {
  return <CloseIcon className={className} onClick={closeToast} />;
}

const data = {
  id: "ffdb3cf5-05e8-446d-8daa-fe054e2d740b",
  firstName: "Vijayathiraj",
  lastName: "S",
  mobile: "8870762077",
  personalEmail: "vijayathiraj77@gmail.com",
  maritalStatus: "Single",
  currentAddress: "10A/39 Perumalpatti, Srivilliputtur, Virudhunagar",
  permanentAddress: "10A/39 Perumalpatti, Srivilliputtur, Virudhunagar",
  joinningDate: null,
  fatherName: "Sivanraj",
  motherName: "Athilakshmi",
  spouseName: "NA",
  dob: "2000-06-01T18:30:00.000Z",
  gender: "Male",
  emergencyMobile: "7845684450",
  emergencyContactRelation: "Dad",
  bloodGroup: "AB+",
  totalExperience: "2",
  uanNumber: null,
  pfNumber: null,
  esiNumber: null,
  aadhaarNumber: "XXXXXXXXXXXXXX",
  panNumber: "XXXXXXXXXXXXXX",
  candidateId: "9456969f-ab67-40ce-98bd-adef047458a6",
  createdAt: "2025-01-03T10:37:15.469Z",
  updatedAt: "2025-01-03T10:37:15.469Z",
};
